export default async function GetPolicySummary(
    distributorClientNo
    ) {
    const url = "/api/TAL/PolicyDetails/GetPolicySummary?distributorClientNo="+ distributorClientNo;
    //const url = "https://adviser-local-sitecore10.delivery.lan" + "/api/TAL/PolicyDetails/GetPolicySummary?distributorClientNo="+ distributorClientNo;// note: local testing        

    try {
        const response = await fetch(url, {
            "method": "GET"
        });

        if (!response) {
            throw Error("No response");
        } else if (!response.ok) {
            throw Error(response.statusText);
        }

        const result = await response.json();
        return result; 
    } catch (error) {
        console.log(error);
    }
}
